import React, { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import IdleTimer from 'react-idle-timer';
import ModalSimple from '@ch/common/components/modal/modals/simple-modal';
import { RoutePath } from './const';
import { useData } from './use-data';

const IdleTimerComponent: FC = () => {
  const navigate = useNavigate();
  const {
    data: {
      keywords: { idelTime, idelTimoutsec, timeoutSec, continueButton },
      theme: { btnDark },
    },
  } = useData();
  const [isIdel, setIsIdel] = useState(false);

  const handleOnIdle = () => {
    setIsIdel(true);
  };
  const handleOnTimeout = () => {
    setIsIdel(false);
    navigate(`${RoutePath.HOME}?timeout=true`);
  };

  return (
    <>
      <IdleTimer timeout={idelTimoutsec * 1000} onIdle={handleOnIdle} debounce={500} />
      <IdleTimer timeout={timeoutSec * 1000} onIdle={handleOnTimeout} debounce={500} />
      <ModalSimple
        isOpen={isIdel}
        hideClose
        btnTheme={btnDark}
        onSubmit={{
          title: continueButton,
          action: () => {
            setIsIdel(false);
          },
        }}
      >
        <span>{idelTime}</span>
      </ModalSimple>
    </>
  );
};

export default IdleTimerComponent;
